<template>
  <div v-if="zeroValue" class="calibration-card" data-cy="addUserZeroConfirmationText">
    <p class="tab-content__title">
      {{ $t('map.deviceSettings.zeroing.confirmation.userZero.title') }}
    </p>
    <p>
      {{ $t('map.deviceSettings.zeroing.confirmation.userZero.paragraph1') }}
    </p>
    <p>
      {{ $t('map.deviceSettings.zeroing.confirmation.userZero.paragraph2') }}
    </p>
  </div>
  <div v-else class="calibration-card" data-cy="removeUserZeroConfirmation">
    <p class="tab-content__title">
      {{ $t('map.deviceSettings.zeroing.confirmation.factoryZero.title') }}
    </p>
    <p>
      {{ $t('map.deviceSettings.zeroing.confirmation.factoryZero.paragraph1') }}
    </p>
    <p>
      {{ $t('map.deviceSettings.zeroing.confirmation.factoryZero.paragraph2') }}
    </p>
    <p>
      {{ $t('map.deviceSettings.zeroing.confirmation.factoryZero.paragraph3') }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DeviceZeroConfirmation',
  props: {
    zeroValue: {
      type: Boolean,
      required: true
    }
  }
})
</script>

<style lang="scss" scoped>
.tab-content__title {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  opacity: 0.56;
  margin-top: 0;
}
</style>
